/**
 * DO NOT CHANGE ANYTHING IN THIS FILE .
 */
import { getAPPID } from '../components/common/Helpers';
import { validateUrl } from '../components/common/Helpers/xss';
import { apiUrls } from '../constants/apiUrl';

const getContextURL = (nonSecure) => {
  if (window.location.hostname === 'localhost') {
    return 'http://localhost:4001';
  }

  // QA and Prod Env
  if (nonSecure) {
    // common urls
    return '/soe/digital';
  }
  return getAPPID() === 'AAL' ? '/soe/digital/auth' : '/soe/digital/prospect';
};

/**
 * @param [string] - (prospect) api url - /cartservice/cart/nse/5g/retrieve-cart
 * @returns api url
 * /soe/digital/prospect/cartservice/cart/nse/5g/retrieve-cart
 * /soe/digital/auth/cartservice/cart/5g/retrieve-cart
 */
export const getDigitalURL = (url, isEmailValidate) => {
  // const isLoggedIn = window?.vzFlags?.isLoggedIn;
  const isLoggedIn = window?.vzFlags?.appId === 'AAL';

  const serviceUrl = isLoggedIn && !isEmailValidate ? url.replace('/nse/', '/') : url;
  if (window.location.hostname === 'localhost') {
    return `http://localhost:4001${serviceUrl}`;
  }
  if (isLoggedIn) {
    return `/soe/digital/auth${serviceUrl}`;
  }
  return `/soe/digital/prospect${serviceUrl}`;
};

// Use the below URL for Modules which will be used for prospect flows

// Use the below URL for Logged in scenarios
// export const getSecureBaseUrl = () => getContextURL();
export const getSecureBaseUrl = (nonSecure) => getContextURL(nonSecure);

export const getBaseUrl = () => {
  const hostName = window.location.hostname;
  let apiData;
  if (hostName.indexOf('www.verizon.com') !== -1) {
    apiData = { baseUrl: `https://api.verizon.com`, apiKey: '5vbCkJw5g5e3LNaY8cgcnPpyQGPrhjIw', queryParam: '&sortByState=MD' };
  } else {
    apiData = { baseUrl: `https://api-stg.verizon.com`, apiKey: 'YT2N6GkuOjvISXmvQUeSW5XA1MA990VF', queryParam: '' };
  }
  return apiData;
};

export const getBaseUrlOfNTAS = (data) => {
  const hostName = window.location.hostname;
  let apiData;
  if (hostName.indexOf('www.verizon.com') !== -1) {
    apiData = { baseUrl: `https://api.verizon.com`, authorization: data };
  } else {
    apiData = { baseUrl: `https://api-qa.ebiz.verizon.com`, authorization: data };
  }
  return apiData;
};
export const getBaseUrlOfAuthToken = () => {
  const hostName = window.location.hostname;
  let apiData;
  if (hostName.indexOf('www.verizon.com') !== -1) {
    apiData = `https://www.verizon.com`;
  } else {
    apiData = `https://wwwawssit.ebiz.verizon.com`;
  }
  return apiData;
};

// Use the below URL for Non Logged in scenarios
export const getURL = (url) => {
  // (url, useDigital)
  if (!url || url === '') {
    // getURL is no longer being used the same way as BAU, if you are getting this error you probably copy pasted code from Digital which you  should not have done.
    throw new Error('getUrl method is being used incorrectly');
  }

  if (url.indexOf('sales/movers') > 0) {
    return validateUrl(url);
  }
  return validateUrl(url);
  // If it is outside the digital or next context paths or if there isn't any cradle cookie configured then it will continue in the current context path
  // return validateUrl(getContextPath() + url);
};

export const getVzwCorpUrl = () => {
  const hostName = window.location.hostname;
  let APIContext = 'https://vzwqa7.sdc.vzwcorp.com/support/important-plan-information/?type=app';
  if (hostName.indexOf('www.verizon.com') !== -1) {
    APIContext = `https://${hostName}${apiUrls().importantPlanInfo}`;
  }
  APIContext = `https://${hostName}${apiUrls().importantPlanInfo}`;
  return APIContext;
};

export const getAccMgrUrl = () => {
  const hostName = window.location.hostname;
  let APIContext = '';
  if (hostName.indexOf('.verizonwireless.com') > -1) {
    const qaEnv = window.location.host.split('.');
    const lowerEnv = qaEnv[0].substr(qaEnv[0].length - 3);
    const number = lowerEnv.match(/(\d+)/);
    if (number[0] > 9) {
      APIContext = `https://accessmgrqa${number[0]}.verizonwireless.com`;
    } else {
      APIContext = `https://accessmgr${lowerEnv}.verizonwireless.com`;
    }
  } else if (hostName.indexOf('wwwnssit5.verizon.com') > -1) {
    APIContext = 'https://securesit5.verizon.com';
  } else {
    APIContext = 'https://secure.verizon.com';
  }
  return `${APIContext}`;
};

export const getAMLoginURL = () => {
  // https://secure.verizon.com/vzauth/UI/Login
  // https://accessmgrqa1.verizonwireless.com/vzauth/UI/Login
  const hostName = window.location.hostname;
  let APIContext = '';
  if (hostName.indexOf('.verizonwireless.com') > -1) {
    const qaEnv = window.location.host.split('.');
    const lowerEnv = qaEnv[0].substr(qaEnv[0].length - 3);
    const number = lowerEnv.match(/(\d+)/);
    if (number[0] > 9) {
      APIContext = `https://accessmgrqa${number[0]}.verizonwireless.com/vzauth/UI/Login`;
    } else {
      APIContext = `https://accessmgr${lowerEnv}.verizonwireless.com/vzauth/UI/Login`;
    }
  } else {
    APIContext = 'https://secure.verizon.com/vzauth/UI/Login';
  }
  return `${APIContext}`;
};

const getWebAMLoginURL = () => {
  // https://secure.verizon.com/vzauth/UI/Login
  // https://accessmgrqa1.verizonwireless.com/vzauth/UI/Login
  const hostName = window.location.hostname;
  let APIContext = '';
  if (hostName.indexOf('.verizonwireless.com') > -1) {
    const qaEnv = window.location.host.split('.');
    const lowerEnv = qaEnv[0].substr(qaEnv[0].length - 3);
    const number = lowerEnv.match(/(\d+)/);
    if (number[0] > 9) {
      APIContext = `https://accessmgrqa${number[0]}.verizonwireless.com/vzauth/UI/Login?&goto=https://vzw${number[0]}.verizonwireless.com/5g/home`;
    } else {
      APIContext = `https://accessmgr${lowerEnv}.verizonwireless.com/vzauth/UI/Login?&goto=https://vzw${lowerEnv}.verizonwireless.com/5g/home`;
    }
  } else {
    APIContext = 'https://secure.verizon.com/vzauth/UI/Login?&goto=https://www.verizon.com/5g/home';
  }
  return `${APIContext}`;
};
export default getWebAMLoginURL;

export const getAutoPayUrl = () => '/digital/nsa/secure/ui/payment/settings/#/';

export const getAEMBaseUrl = (customContext) => {
  const context = customContext || 'content/vcg';
  if (window.location.hostname === 'localhost') {
    return `http://localhost:4001/${context}`;
  }
  return `/${context}`;
};
